import { PropsWithChildren, FC } from 'react'
import { DragOutlined } from '@ant-design/icons'

import Box from '~/core/Box'

interface ImDfmDragHoverIconPropsType {
    hovering: boolean
}

// IM-1113 / IM-1385
const ImDfmDragHoverIcon: FC<
    PropsWithChildren<ImDfmDragHoverIconPropsType>
> = ({ hovering = false, children }) => (
    <Box display="flex">
        <div style={{ flex: '1 1 auto' }}>{children}</div>
        {hovering && (
            <div style={{ justifyContent: 'flex-end', flex: '0 0 16px' }}>
                <DragOutlined style={{ fontSize: '16px', color: '#4B7FFC' }} />
            </div>
        )}
    </Box>
)

export default ImDfmDragHoverIcon
